import maddyApi from '@/services/maddyApi';

const errorHandler = e => {
  if (e.response) {
    return e.response;
  } else if (e.request) {
    return e.request;
  } else {
    return e;
  }
};

export default {
  namespaced: true,
  state: {
    title: '',
    description: '',
    references: null,
    deadline: '',
    id: '',
    gallery: [],
    galleryStudyId: '',
    referencesStudyId: '',
  },
  getters: {
    deadlinePassed(state) {
      const now = new Date();
      const deadline = new Date(state.deadline);

      return now - deadline > 0;
    },
  },
  actions: {
    async getStudy({ commit }, id) {
      try {
        const response = await maddyApi.get(`/studies/${id}`);
        if (!response.error) {
          commit('SET_STUDY', response.data);
          return response.data;
        } else {
          return response.error;
        }
      } catch (err) {
        return errorHandler(err);
      }
    },
    async getGallery({ commit, state }) {
      let endpoint = `/studies/${state.id}/gallery`;
      try {
        const response = await maddyApi.get(endpoint);
        if (!response.error) {
          commit('SET_GALLERY', response.data);
        } else {
          return response.error;
        }
      } catch (err) {
        return errorHandler(err);
      }
    },
    async getReferences({ commit, state }, id) {
      state.references = null;
      let endpoint = `/studies/${id}/references`;
      try {
        const response = await maddyApi.get(endpoint);
        if (!response.error) {
          commit('SET_REFERENCES', response.data);
        } else {
          return errorHandler(response.error);
        }
      } catch (err) {
        return errorHandler(err);
      }
    },
  },
  mutations: {
    SET_GALLERY(state, payload) {
      state.gallery = payload;
      state.galleryStudyId = `${state.id}`;
    },
    SET_REFERENCES(state, payload) {
      state.references = payload;
      state.referencesStudyId = `${state.id}`;
    },
    SET_STUDY(state, payload) {
      state.title = payload.title;
      state.description = payload?.description;
      state.deadline = payload.deadline;
      state.id = payload?.id;
    },
  },
};
